import { render, staticRenderFns } from "./CcedView.vue?vue&type=template&id=2a8631f4"
import script from "./CcedView.vue?vue&type=script&lang=js"
export * from "./CcedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports